/**
 * Where the API lives (TechSpec §10.1.1).
 *
 * Empty on web and in desktop dev: requests stay same-origin, through Caddy or
 * Vite's proxy. A packaged desktop app loads from the app protocol, so its
 * build bakes in the production origin from `.env.desktop`.
 */
const EXACT_ORIGIN = /^https?:\/\/[^/\s]+$/;

export function resolveApiOrigin(value: string | undefined): string {
  if (value === undefined || value === '') return '';
  if (!EXACT_ORIGIN.test(value)) {
    throw new Error(`VITE_API_ORIGIN must be an origin like https://host, got ${value}`);
  }
  return value;
}

export const API_ORIGIN = resolveApiOrigin(import.meta.env.VITE_API_ORIGIN);

/** An absolute URL on the desktop build, the path itself everywhere else. */
export const apiUrl = (path: string): string => `${API_ORIGIN}${path}`;
